module.exports = __webpack_public_path__ + "img/百香果1.dad321b8.png";